import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jwmProductHeading: {
		id: 'project-create-importer-upload-flow.select-product-screen.jwm-product-heading',
		defaultMessage: 'Import into a new business project',
		description: 'Import to a business project heading',
	},
	jwmProductDescription: {
		id: 'project-create-importer-upload-flow.select-product-screen.jwm-product-description',
		defaultMessage: 'Manage your work using list, board, calendar, or timeline view.',
		description: 'Import your work to Jira Work Management description',
	},
	jswProductHeadingNew: {
		id: 'project-create-importer-upload-flow.select-product-screen.jsw-product-heading-new',
		defaultMessage: 'Import into a new software project',
		description: 'Import to a new software project new heading',
	},
	jswProductDescription: {
		id: 'project-create-importer-upload-flow.select-product-screen.jsw-product-description',
		defaultMessage: 'Manage development processes with agile and DevOps practices.',
		description: 'Import to Jira Software description',
	},
	jsmProductHeading: {
		id: 'project-create-importer-upload-flow.select-product-screen.jsm-product-heading',
		defaultMessage: 'Import to new or existing service projects',
		description: 'Import to a service project heading',
	},
	jsmProductDescription: {
		id: 'project-create-importer-upload-flow.select-product-screen.jsm-product-description',
		defaultMessage: 'Manage incoming requests from multiple channels and respond at scale.',
		description: 'Import your data in a Jira Service Management project description',
	},
	heading: {
		id: 'project-create-importer-upload-flow.select-product-screen.heading',
		defaultMessage: 'Import data',
		description: 'Import data heading',
	},
	description: {
		id: 'project-create-importer-upload-flow.select-product-screen.description',
		defaultMessage: 'Select how and where you’d like to import your data.',
		description: 'Import your data description',
	},
	importIntoExistingJiraProject: {
		id: 'project-create-importer-upload-flow.select-product-screen.import-into-existing-jira-project',
		defaultMessage: 'Import into an existing Jira project',
		description: 'Import into an existing Jira project',
	},
	marketing: {
		id: 'project-create-importer-upload-flow.select-product-screen.marketing',
		defaultMessage: 'Marketing',
		description: 'Text for Marketing team lozenge',
	},
	design: {
		id: 'project-create-importer-upload-flow.select-product-screen.design',
		defaultMessage: 'Design',
		description: 'Text for Design team lozenge',
	},
	hr: {
		id: 'project-create-importer-upload-flow.select-product-screen.hr',
		defaultMessage: 'HR',
		description: 'Text for HR team lozenge',
	},
	legal: {
		id: 'project-create-importer-upload-flow.select-product-screen.legal',
		defaultMessage: 'Legal',
		description: 'Text for Legal team lozenge',
	},
	software: {
		id: 'project-create-importer-upload-flow.select-product-screen.software',
		defaultMessage: 'Software',
		description: 'Text for Software team lozenge',
	},
	agile: {
		id: 'project-create-importer-upload-flow.select-product-screen.agile',
		defaultMessage: 'Agile',
		description: 'Text for Agile team lozenge',
	},
	devops: {
		id: 'project-create-importer-upload-flow.select-product-screen.devops',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Devops',
		description: 'Text for Devops team lozenge',
	},
	it: {
		id: 'project-create-importer-upload-flow.select-product-screen.it',
		defaultMessage: 'IT',
		description: 'Text for IT team lozenge',
	},
	facilities: {
		id: 'project-create-importer-upload-flow.select-product-screen.facilities',
		defaultMessage: 'Facilities',
		description: 'Text for facilities team lozenge',
	},
	poweredByJwmSpork: {
		id: 'project-create-importer-upload-flow.select-product-screen.powered-by-jwm-spork',
		defaultMessage: 'Powered by {linkStart}Jira{linkEnd}',
		description: 'Powered by Jira link description',
	},
	poweredByJswSpork: {
		id: 'project-create-importer-upload-flow.select-product-screen.powered-by-jsw-spork',
		defaultMessage: 'Powered by {linkStart}Jira{linkEnd}',
		description: 'Powered by JSW link description',
	},
	poweredByJsm: {
		id: 'project-create-importer-upload-flow.select-product-screen.powered-by-jsm',
		defaultMessage: 'Powered by {linkStart}Jira Service Management{linkEnd}',
		description: 'Power by JSM link description',
	},
});
